import React, {useState, useEffect} from 'react'
import Template from '../component/template'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import { Alerts} from '../component/notify'
import PageHeader from '../component/pageheader'
import {Currency, FormatNumber, ImagesUrl, ServerUrl,  Token, config, schoolName} from '../component/include'

import Select from 'react-select'
import {  longDate} from '../component/globalFunction'
import { userToken } from '../component/authentication'

import Error403 from '../settings/error403'
import { useLocation } from 'react-router-dom'
import { verifyRouter } from '../component/authentication'
import { useSelector } from 'react-redux'
const AccountStatement =()=> {
    const [errors, setErrors] = useState({});
    const schoolInfo  = useSelector(state => state.rootReducer.schoolInfo);
    const [account, setAccount]=useState([])

    const [result, setResult] = useState([])
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    }); 
    
    let location =  useLocation()
    const [isAuthenticated, setIsAuthenticated] = useState(true);
    const [statement, setStatement] = useState({
       account:[],
       fromDate:'',
        toDate:'',
        credit:0,
        debit:0,
        balanceOpen:0
    })



    const fetchAccount=()=>{
        var sql =  'select  a.accountName, a.code, a.openingBalance as balanceOpen,  (coalesce(a.openingBalance,0) - coalesce((select sum(e.amount) from tbl_expenses e where e.account = a.code  group by e.account),0) + coalesce((select sum(i.amount) from tbl_income i where i.account = a.code  group by i.account),0) -  coalesce((select sum(s.totalAmount) from tbl_salary_payment  s where s.paymentAccount = a.code group by s.paymentAccount),0)) as openingBalance from tbl_account a'
          
          setNotice({...notice, isLoading: true}) 
          const fd = new FormData();
          fd.append('jwt', Token); 
          fd.append("sql", sql);
          let url = ServerUrl+'/fetchBySql_controller'
          axios.post(url, fd, config).then(result=> setAccount(result.data))
          .catch((error)=>{
          Alerts('Error!', 'danger', error.message)
          }).finally(()=>{
          setNotice({...notice, isDataFetching: false})
  
          })  
      }

        
        const handleSelect= (option, action)=>{
            setStatement({...statement, [action.name]:option, balanceOpen:option.balanceOpen});
            setErrors({...errors, [action.name]:''})
            setResult('')
        }

        const handleChange=(event)=>{
            const {name, value} = event.target;
            setStatement({...statement, [name]:value})
            setErrors({...errors, [name]:''})
            setResult('')
            
        }
    
            const fetchResult =()=>{
                 if(statement.account.length===0){
                    setErrors({...errors, account:'Please select account'})
                }else if(!statement.fromDate){
                    setErrors({...errors, fromDate:'Please select from date'})
                }else if(!statement.toDate){
                    setErrors({...errors, toDate:'Please select to date'})
                } else{ 
                
                
                    var sql = 'Select i.account, i.amount, i.incomeDate, i.remarks, h.headName, (case when i.incomeCode=h.code then "credit" else " " end) as type  from tbl_income i, tbl_income_head h where i.incomeCode = h.code and i.account = "'+statement.account.value+'" and i.incomeDate >= "'+statement.fromDate+'" and i.incomeDate <= "'+statement.toDate+'" union Select e.account, e.amount, e.expensesDate, e.remarks, p.headName, (case when e.expensesCode =p.code then "debit" else " " end) as type from tbl_expenses e, tbl_expenses_head p where e.expensesCode = p.code and e.account = "'+statement.account.value+'" and e.expensesDate >= "'+statement.fromDate+'" and e.expensesDate <= "'+statement.toDate+'" order by incomeDate'
        
  setNotice({...notice, isLoading: true}) 
  const fd = new FormData();
  fd.append('jwt', Token); 
            fd.append("sql", sql);
            console.log(sql)
            let url = ServerUrl+'/fetchBySql_controller'
            axios.post(url, fd, config).then(result=>{
                if(result.data.length!==0){
                    var credit = 0, debit = 0;
                    result.data.map(data=>data.type==='debit'?debit+=Number(data.amount):credit+=Number(data.amount))
                    setResult(result.data)
                    setStatement({...statement, debit:debit, credit:credit})
                }else{
                    Alerts('Info!', 'default', 'No record found for the selected criterials')
                }
                
            })
            .catch((error)=>{
            Alerts('Error!', 'danger', error.message)
            }).finally(()=>{
                setNotice({...notice, isLoading: false})
                
            })   
        } 
            }
    
     
     useEffect(()=>{
        setIsAuthenticated(verifyRouter(location.pathname))
        fetchAccount()
    },[]);


        return (  
            <>
           <div  className="main-body">
           {isAuthenticated?   <div className="page-wrapper">
                         {notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Account Statement">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-money"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Finance</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Account Statement</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">

                <div className="row  ">
						
                        <div className="col-sm-12">
                    
                        <div className="card z-depth-0">
                            <div className="card-header">
                                <h5><i className="fa fa-edit" ></i> Account Statement</h5>
                                <div className="card-header-right">
                                    <ul className="list-unstyled card-option">
                                        <li><i className="feather icon-maximizes full-card"></i></li>
                                        <li><i className="feather icon-minus minimize-card"></i></li>
                                        <li><i className="feather icon-trash-2 close-card"></i></li>
                                    </ul>
                                </div>
                            </div>
                            
                            
                            <div className="card-block">
        
        <div  className="card-block">
        <div  className="card z-depth-0" >

		<div  className="card-block">
		
        <div className="row">
        <section className="col-md-6">
            <div className="form-group">
						<label >Account <span style={{color:'red'}}>*</span> </label>
						<Select options={
                             account&&account.map((list, idx)=> {
                                return {key:idx, value: list.code, label: list.accountName, balance:list.openingBalance, balanceOpen:list.balanceOpen}
                             })} 
                             getOptionLabel={option =>` ${option.label} Balance: ${Currency+FormatNumber(option.balance)}`}
onChange={handleSelect} className={errors.account? 'form-control form-control-danger' : ''} name="account" value={statement.account}  /> <span style={{color:'red'}}>{errors.account && errors.account}</span>
										  </div>

      </section>
      
      <section className="col-md-3">
      <div className="form-group">
   <label >From Date <span style={{color:'red'}}>*</span></label>
   <input type="date" className={errors.fromDate ? 'form-control form-control-danger' : 'form-control'} name="fromDate"   onChange={handleChange} value={statement.fromDate} />

   <span style={{color:'red'}}>{errors.fromDate && errors.fromDate}</span>
               </div>

   

</section>
      <section className="col-md-3">
      <div className="form-group">
   <label >To Date <span style={{color:'red'}}>*</span></label>
   <input type="date" className={errors.toDate ? 'form-control form-control-danger' : 'form-control'} name="toDate"   onChange={handleChange} value={statement.toDate} />

   <span style={{color:'red'}}>{errors.toDate && errors.toDate}</span>
               </div>

</section>	
      


				</div>	

<div className="row" >
<section className="col-md-12">
	<footer className="pull-right">
	
	<button type="button" id="submit" onClick={()=>fetchResult()} className="btn btn-primary "><i className="fa fa-search"></i> Search</button>
								</footer>		</section>		
                                </div>
                            
                            
                            </div></div> 
							</div></div>
</div>
</div>
</div>



{result.length!==0?
    <div className="card z-depth-0">
		<div className="card-block">
	
        {schoolInfo&&schoolInfo.map((st, id)=>
                       <table className='table' key={id}>
       <tbody>
                <tr>
                <td className="text-center" ><img id="viewSchoolLogo2" className="img-100" onError={(e)=>{e.target.onerror = null; e.target.src=ImagesUrl+'/logo.png'}} src={`${ImagesUrl}/about/${st.schoolLogo}`}  title="School Logo" alt=''  />
<h4 style={{textAlign:'center'}}><b>{st.schoolName}</b></h4>
<h6 style={{textAlign:'center'}}><b>Motto: {st.schoolMotto}</b></h6>
<div style={{textAlign:'center'}}>  {st.address}  </div>
<div style={{textAlign:'center'}}> {st.mobile}, {st.altMobile}, {st.email} </div>

<div style={{textAlign:'center'}}>  Website: {st.website}  </div>
 </td>
                </tr>
            </tbody>
       </table>  )} 
 <div className="row">
        <div className="col-md-12">
        <h5 style={{textAlign:'center'}}><u><b>STATEMENT OF ACCOUNT </b></u></h5>
        </div></div><br/>



<div className="row">
<div className="col-md-12 table-responsive">

       <table className="table table-bordered  table-full-width">
       <tbody>
                <tr>
                    <td >Account: <br/><b>{statement.account.value+' - ' +statement.account.label}</b></td>
                    <td >Date Range: From <br/><b>{longDate(statement.fromDate)+ ' to '+ longDate(statement.toDate)}</b></td>
                    <td >Opening Balance: <br/> <b>{Currency+FormatNumber(statement.balanceOpen)}</b></td>
                </tr>
            </tbody>
       </table>
       <table className="table table-striped table-bordered">
        <thead>
                <tr>
                <th>S/N</th>
                <th>Txn Date</th>
                    <th>Description</th>
                    <th>Debit ({Currency})</th>
                    <th>Credit ({Currency})</th>
                </tr>
              </thead>
              <tbody>
              {result.length!==0?result.map((st, idx)=> 
                <tr key={idx}>
                <td>{idx+1}</td>
                <td>{longDate(st.incomeDate)}</td>
                <td>{st.headName+' '+st.remarks}</td>
                <td>{st.type==='debit'?FormatNumber(st.amount):''}</td>
                <td>{st.type==='credit'?FormatNumber(st.amount):''}</td>
                </tr>):[]}
              </tbody>
            <tfoot>
                <tr>
                <th colSpan='3'>Current Balance: <b>{Currency+FormatNumber(statement.account.balance)}</b></th>
                    <th>Total Debit: <b>{Currency+FormatNumber(statement.debit)}</b></th>
                    <th>Total Credit: <b>{Currency+FormatNumber(statement.credit)}</b></th>
                </tr>
            </tfoot>

        </table>
 </div>	 </div> 

 <div className="row">
        <div className="col-md-12">
        <form method='POST' action={ServerUrl+'/printout/account_statement.php?token='+userToken} target='_blank'>
                <input type='hidden' name='result' value ={JSON.stringify(result, null, 2)} />
                <input type='hidden' name='account' value ={statement.account.value+' - ' +statement.account.label} />
                <input type='hidden' name='jwtToken' value ={Token} />
                <input type='hidden' name='debit' value ={statement.debit} />
                <input type='hidden' name='credit' value ={statement.credit} />
                
                <input type='hidden' name='balanceOpen' value ={statement.balanceOpen} />
                <input type='hidden' name='balance' value ={statement.account.balance} />
                <input type='hidden' name='dateRange' value ={longDate(statement.fromDate)+ ' to '+ longDate(statement.toDate)} />
        <button type="submit" className="btn btn-inverse pull-right no-print" > <i className="fa fa-print"></i> Print</button>
        
        </form>
        </div></div>

 </div>
        </div>:''}



   </div>
          {/* The Page Body close here */}

            </div>:
            <Error403 />}
            </div>

</> 
 );
        
}

export default React.memo(AccountStatement) 